import { Component, OnInit, OnChanges } from '@angular/core';
import { PworkflowComponent } from '../index';

@Component({
  selector: 'header-tag',
  templateUrl : 'header.component.html'
})
export class HeaderComponent implements OnInit {

  constructor(public _parent: PworkflowComponent) {}

  ngOnInit(){

  }

  loginsubmit(){
    this._parent.index = -1;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/header/header.component.ts